import {
  Grid,
  TextField,
  Typography,
  withStyles,
  createStyles,
  Theme,
  WithStyles,
} from "@material-ui/core";
import React, { Component } from "react";
import { MyPATExpansionPanel, MyPATSelect } from "../../../common";
import {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../../common/MyPATBaseSection";
import AddFeedback from "../../../content-request/components/AddFeedback";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import AddFeedbackPopup from "./AddFeedbackPopup";
import { CONTENT_SUB_TYPE, SECTIONS } from "../../helper/contentValidation";

const styles = (theme: Theme) =>
  createStyles({
    headingTxt: {
      fontSize: "14px",
      lineHeight: "16px",
      color: "#333",
    },
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    blueColor: {
      color: "#1D7DEA",
    },
    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
    grayTxt: {
      color: "#999",
    },
    optionSettingText: {
      width: "67px",
      margin: "0px 10px 0 10px",
      textAlign: "center",
      "& input": {
        padding: "10px",
      },
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
        opacity: 0,
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        appearance: "none",
      },
    },
    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    },
    headingRelative: {
      position: 'relative',
      display: 'inline-block',
    },
    idealTimeError: {
      fontSize:14,
      fontWeight:400,
      lineHeight:'20px',
      textAlign: "left",
      color: "#EB4F4F",
      paddingLeft: '230px'
    }
  });

interface Props extends WithStyles<typeof styles> {
  addFeedback(type: string): void;
  checkFeedback(): boolean;
  openFeedback: boolean;
  idealTime: { value: any; state: number };
  onChangeIdealTime: (e: any, newState?: number) => void;
  authorType?: string;
  replyFeedback: Function;
  closeFeedback: Function;
  resolveFeedback: Function;
  clickedfeedbackData: any;
  addNewFeedback: Function;
  isDisable?: boolean;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
  defaultExpanded?: boolean;
}

class SetIdealTime extends Component<Props> {
  render() {
    const { classes, idealTime, isDisable, checkFeedback = () => false, activeValidationFeedbackSection, activeValidationFeedbackData, handleAddCommentInFeedback, createNewValidationFeedback,defaultExpanded } = this.props;
    return (
      <MyPATExpansionPanel
        isDisable={isDisable}
        hasExpandIcon
        defaultExpanded={defaultExpanded}
        variant="white"
        customCollapseTitle={
          <>
            <Typography
              variant="h6"
              className={[classes.cardHeading, classes.headingRelative].join(' ')}
              onClick={(event) => {
                event.stopPropagation();
                this.props.addFeedback && this.props.addFeedback(CONTENT_SUB_TYPE.IDEAL_TIME);
              }}
            >
              <span
                id={checkFeedback() ? "feedbackScroll" : ""}
                className={`${classes.feedbackContainer} ${
                  checkFeedback() ? classes.blueColor : ""
                } ${this.props.openFeedback ? classes.feedbackHighlight : ""}`}
              >
                Ideal Time
                {checkFeedback() && (
                  <Grid className="feedbackBlock">
                    <AddFeedback
                      author={this.props.authorType}
                      replyFeedback={this.props.replyFeedback}
                      closeFeedback={this.props.closeFeedback}
                      resolveFeedback={this.props.resolveFeedback}
                      clickedfeedbackData={this.props.clickedfeedbackData}
                      addNewFeedback={this.props.addNewFeedback}
                    />
                  </Grid>
                )}
                
              </span>
              <span className={classes.optionalText}>  (Optional)</span>

              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Ideal Time"
                imageURL="/assets/svg/infoIcon/idealTime.svg"
                dialogPara="The Ideal time refers to the appropriate time duration in which the question can be solved"
                details="Click to know more"
                toolTipDirection="top" />
                {
                  activeValidationFeedbackSection === SECTIONS.IDEAL_TIME && (
                    <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                  )
                }
            </Typography>
          </>
        }
      >
        <SectionFocusedContext.Consumer>
          {({ setSectionFocus }: SectionFocusedContextValue) => (<>
            <Grid container alignItems="center">
              <Grid item>
                <Typography className={classes.headingTxt}>
                  Set Ideal Time To Solve{" "}
                  <span className={classes.grayTxt}>(Optional)</span> :
                </Typography>
              </Grid>
              <Grid item>
                <TextField
                  error={idealTime.value === 0}
                  variant="outlined"
                  disabled={false}
                  classes={{ root: classes.optionSettingText }}
                  type="text"
                  value={idealTime.value}
                  // inputProps={{min:0}}
                  onChange={(e: any) => this.props.onChangeIdealTime(e)}
                  onFocus={() => setSectionFocus(true)}
                  onBlur={() => setSectionFocus(false)}
                />
                <MyPATSelect
                  required
                  onChange={(e: any) => {
                    const { value } = e.target;
                    this.props.onChangeIdealTime(null, parseInt(value));
                  }}
                  onFocus={() => setSectionFocus(true)}
                  onBlur={() => setSectionFocus(false)}
                  inputId="idealTimeState"
                  name="idealTimeState"
                  value={this.props.idealTime.state}
                >
                  <option value={1}>Sec</option>
                  <option value={2}>Min</option>
                </MyPATSelect>
                {/* <span className={classes.posRelative}> 
      <TextField
      variant="outlined"
      disabled={false}
      classes={{ root: classes.optionSettingText}}
      type="text"
      value={this.renderIdealTimeState()}
      onFocus={() => setSectionFocus(true)}
      onBlur={() => setSectionFocus(false)}
      />
      <span className={classes.arrowIcon}>
          <Grid className={classes.arrowIconT}
          onClick={() => this.onChangeIdealTime(null, 'up')}>
              <img src="/assets/svg/myLibrary/arrowTop.svg"/>
          </Grid>
          <Grid className={classes.arrowIconB}
          onClick={() => this.onChangeIdealTime(null, 'down')}>
              <img src="/assets/svg/myLibrary/arrowBottom.svg"/>
          </Grid>
      </span>
    </span> */}
              </Grid>
            </Grid>
            {idealTime.value === 0 &&
              <div className={classes.idealTimeError}>
                The ideal time should always be greater than 0
              </div>
            }
            </>
          )}
        </SectionFocusedContext.Consumer>
      </MyPATExpansionPanel>
    );
  }
}

export default withStyles(styles)(SetIdealTime);
